export default [
  {
    path: '/almacen',
    name: 'Warehouse',
    component: () => import('@/views/warehouse/Warehouse.vue'),
    meta: {
      requiresAuth: true,
    },
  },
]
